export default function catchAbortError(error: unknown): void {
  if (!(error instanceof DOMException && error.name === "AbortError")) {
    throw error;
  }
}
